module.exports = __webpack_public_path__ + "static/camera3-c7d96f97da284f1918662555c34ce387.jpg";